import { ChangeDetectionStrategy, Component, Input, OnInit } from "@angular/core";
import { PI_TEXT_CARD_FONT_COLOR_CLASSES, PiTextCardFontColor } from "@webapp/platform-intelligence/shared/models/pi-card.models";

@Component({
  selector: "pi-text-subcard",
  templateUrl: "./pi-text-subcard.component.html",
  styleUrls: ["./pi-text-subcard.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PiTextSubcardComponent implements OnInit {
  @Input()
  public isIconAvailable = true;
  @Input()
  public fontColor: PiTextCardFontColor = "medium";
  @Input()
  public fontColorOnHover: PiTextCardFontColor = "dark";
  @Input()
  public isHovered: boolean;
  @Input()
  public textToDisplay: string | string[];

  public isStringText = true;

  public get fontColorClass(): string {
    if (this.isHovered) {
      return PI_TEXT_CARD_FONT_COLOR_CLASSES[this.fontColorOnHover];
    } else {
      return PI_TEXT_CARD_FONT_COLOR_CLASSES[this.fontColor];
    }
  }

  public ngOnInit(): void {
    this.isStringText = typeof this.textToDisplay === "string";
  }
}
